import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.container = {
    css: css`
        padding: 30px;
        background-color: #ffffff;
        border: 1px solid #efefef;
        box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
    `,
};
